import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'

import { authenticationService } from '@/services/Login'
import { useLoading } from '@/hooks/useLoading'

function ConfirmEmail() {
  const [information, setInformation] = useState('')
  const { SET_LOADING } = useLoading()

  useEffect(() => {
    prepareObject()
  }, [])

  function prepareObject() {
    let params = new URLSearchParams(window.location.search)
    const userId = params.get('userId')
    const newEmail = params.get('newEmail')
    const token = params.get('token')
    const obj = {
      userId,
      newEmail,
      token
    }
    submit(obj)
  }

  async function submit(obj: any) {
    try {
      SET_LOADING(true)
      await authenticationService.changeEmail(obj)
      setInformation('Seu e-mail foi redefinido com sucesso.')
    } catch (e: any) {
      setInformation(
        'Não foi possível alterar seu e-mail, favor tentar novamente'
      )
    } finally {
      SET_LOADING(false)
    }
  }

  return (
    <Box
      display="flex"
      py="77px"
      px={{ md: '16px', xs: '16px' }}
      maxWidth={515}
      m="auto"
      justifyContent="center"
      alignItems="center"
      width="100%"
      flexDirection="column"
    >
      <Typography
        textAlign="center"
        fontSize="30px"
        width="100%"
        marginBottom="8px"
      >
        Alteração de e-mail
      </Typography>
      <Typography
        textAlign="center"
        fontSize="18px"
        width="100%"
        marginBottom="36px"
      >
        {information}
      </Typography>
    </Box>
  )
}

export default ConfirmEmail
